import {
  fetchFundraiser,
  fetchFundraisers,
  putFundraiser,
  sendShareByEmail,
  putFundraiserDates,
} from '@client/connectivity/api.fundraiser';
import { selectAccessToken } from '@client/redux/user';
import {
  generateEmailToken,
  generateFundraiserCommentToken,
} from '@client/connectivity/google.recaptcha';
import { fetchEntries } from '@client/connectivity/api.cms';
import {
  DELETE_FUNDRAISER_COMMENT,
  LOAD_FUNDRAISER,
  LOAD_FUNDRAISER_COMMENT,
  LOAD_FUNDRAISER_TYPE_DATA,
  LOAD_FUNDRAISERS,
  LOAD_MORE_FUNDRAISER_COMMENTS,
  POST_AND_HANDLE_FUNDRAISER_COMMENT,
  PUT_AND_HANDLE_FUNDRAISER,
  SET_FUNDRAISER_ERROR,
  SET_FUNDRAISER_STATUS,
  PUT_AND_HANDLE_FUNDRAISER_DATES,
} from '@client/redux/fundraiser/fundraiserReducer';
import {
  deleteFundraiserComment,
  fetchFundraiserComments,
  postFundraiserComment,
} from '@client/connectivity/api.fundraiserComment';
import { selectFundraiserIdBySlug } from '@client/redux/fundraiser/fundraiserSelectors';
import { LOADING, ERROR, SUCCESS } from '@client/definitions/constants';

export function loadFundraisers(searchParams) {
  return function(dispatch) {
    return fetchFundraisers(searchParams)
      .then((response) => {
        return dispatch({
          type: LOAD_FUNDRAISERS,
          payload: response.data,
        });
      })
      .catch((error) => {
        return setErrorMessage(dispatch, error);
      });
  };
}

export function loadFundraiser(fundraiser) {
  return function(dispatch) {
    setFundraiserStatus(dispatch, LOADING);
    return fetchFundraiser(fundraiser)
      .then((response) => {
        setFundraiserStatus(dispatch, SUCCESS);
        return dispatch({
          type: LOAD_FUNDRAISER,
          payload: response.data,
        });
      })
      .catch((error) => {
        return setFundraiserStatus(dispatch, ERROR);
      });
  };
}

export function putAndHandleFundraiser(formDataFundraiser, fundraiserId) {
  return function(dispatch, getState) {
    const accessToken = selectAccessToken(getState());

    return putFundraiser(formDataFundraiser, fundraiserId, accessToken).then(
      (response) => {
        return dispatch({
          type: PUT_AND_HANDLE_FUNDRAISER,
          payload: response.data,
        });
      }
    );
  };
}

export function putAndHandleFundraiserDates(formDataFundraiser, fundraiserId) {
  return function(dispatch, getState) {
    const accessToken = selectAccessToken(getState());

    return putFundraiserDates(
      formDataFundraiser,
      fundraiserId,
      accessToken
    ).then((response) => {
      return dispatch({
        type: PUT_AND_HANDLE_FUNDRAISER_DATES,
        payload: response.data,
      });
    });
  };
}

export function shareByEmail(fundraiserId, email) {
  return function() {
    return generateEmailToken().then((token) => {
      return sendShareByEmail(token, fundraiserId, email);
    });
  };
}

export function loadFundraiserTypes() {
  return function(dispatch) {
    return fetchEntries('fundraiserType').then((response) => {
      return dispatch({
        type: LOAD_FUNDRAISER_TYPE_DATA,
        payload: response,
      });
    });
  };
}

export function loadFundraiserComment(fundraiserSlug) {
  return function(dispatch, getState) {
    const state = getState();
    const accessToken = selectAccessToken(state);

    return fetchFundraiserComments(accessToken, fundraiserSlug).then(
      (response) => {
        return dispatch({
          type: LOAD_FUNDRAISER_COMMENT,
          payload: response.data,
        });
      }
    );
  };
}

export function loadMoreFundraiserComments(fundraiserSlug, page = 1) {
  return function(dispatch, getState) {
    const state = getState();
    const accessToken = selectAccessToken(state);
    const fundraiserId = selectFundraiserIdBySlug(state, fundraiserSlug);

    return fetchFundraiserComments(accessToken, fundraiserId, page).then(
      (response) => {
        return dispatch({
          type: LOAD_MORE_FUNDRAISER_COMMENTS,
          payload: response.data,
        });
      }
    );
  };
}

export function postAndHandleFundraiserComment(
  fundraiserSlug,
  fundraiserComment
) {
  return function(dispatch, getState) {
    const state = getState();
    const accessToken = selectAccessToken(state);
    const fundraiserId = selectFundraiserIdBySlug(state, fundraiserSlug);
    return generateFundraiserCommentToken().then((recaptchaToken) => {
      return postFundraiserComment(
        accessToken,
        fundraiserId,
        fundraiserComment,
        recaptchaToken
      )
        .then((response) => {
          return dispatch({
            type: POST_AND_HANDLE_FUNDRAISER_COMMENT,
            payload: response,
          });
        })
        .catch((error) => {
          return setErrorMessage(dispatch, error);
        });
    });
  };
}

export function deleteAndHandleFundraiserComment(fundraiserId, commentId) {
  return function(dispatch, getState) {
    const accessToken = selectAccessToken(getState());

    return deleteFundraiserComment(accessToken, fundraiserId, commentId)
      .then((response) => {
        return dispatch({
          type: DELETE_FUNDRAISER_COMMENT,
          payload: commentId,
        });
      })
      .catch((error) => {
        return setErrorMessage(dispatch, error);
      });
  };
}

function setErrorMessage(dispatch, error) {
  return dispatch({
    type: SET_FUNDRAISER_ERROR,
    payload: error,
  });
}

function setFundraiserStatus(dispatch, status) {
  return dispatch({
    type: SET_FUNDRAISER_STATUS,
    payload: status,
  });
}
